import React from "react";

const InsightsIcon = ({ color = "currentColor" }) => (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M20.293 10.293C20.6835 9.90243 21.3166 9.90243 21.7071 10.293C22.0976 10.6835 22.0976 11.3165 21.7071 11.707L15.7071 17.707C15.3166 18.0975 14.6835 18.0975 14.293 17.707L10 13.414L3.70708 19.707C3.31655 20.0975 2.68354 20.0975 2.29302 19.707C1.90249 19.3165 1.90249 18.6835 2.29302 18.293L9.29302 11.293L9.36919 11.2246C9.76196 10.9042 10.341 10.9268 10.7071 11.293L15 15.5859L20.293 10.293Z" fill={color} />
  <path d="M15 10L15.94 7.93L18 7L15.94 6.07L15 4L14.08 6.07L12 7L14.08 7.93L15 10Z" fill={color} />
  <path d="M4.5 12L5 10L7 9.5L5 9L4.5 7L4 9L2 9.5L4 10L4.5 12Z" fill={color} />
</svg>
);

export default InsightsIcon;
